(function(angular){
	'use strict';
	
	var progressMeterObject = {
		templateUrl: [
			'STATIC_BASE_PATH',
			templateUrlFunction
		],
		bindings: {
			step: '<',
			totalSlides: '@'
		},
		controller: ProgressMeterCtrlFunction,
		controllerAs: 'progressMeter'
	};
	
	angular
		.module('slideModule')
		.component('progressMeterSlider', progressMeterObject);
	
	function templateUrlFunction(STATIC_BASE_PATH){
		return STATIC_BASE_PATH + '/static/html/ria/slide/progress-meter-slider.html';
	}
	
	function ProgressMeterCtrlFunction(){
		var progressMeter = this;
		
		progressMeter.$onInit = function(){
			updateMeter();
		};
		
		progressMeter.$onChanges = function(changesObj) {
			if(!changesObj.step.isFirstChange()) {
				updateMeter();
			}
		};

		function updateMeter() {
			progressMeter.meterWidth = {
				'width' : (progressMeter.step / progressMeter.totalSlides) * 100 + '%'
			};
		}
	}
})(window.angular);